import { useMemo } from 'react';
import { useCart } from './useCart';
import { LineItem } from './cart.rest';

export const isLineItemAvailableNow = (lineItem: LineItem) =>
  lineItem.attributes.isProductAvailable &&
  !lineItem.attributes.error &&
  lineItem.attributes.isAvailableNow;

export const useCartItems = () => {
  const { cart } = useCart();
  const cartItems = useMemo(() => cart.attributes.cartItems.map(item => item.data), [cart]);

  const availableNowItems = useMemo(() => cartItems.filter(isLineItemAvailableNow), [cartItems]);

  const preorderItems = useMemo(
    () =>
      cartItems.filter(
        item =>
          item.attributes.isProductAvailable &&
          !item.attributes.error &&
          !item.attributes.isAvailableNow
      ),
    [cartItems]
  );

  const unavailableItems = useMemo(
    () =>
      cartItems.filter(
        item =>
          !item.attributes.isProductAvailable ||
          ['SHORT_SOLD_OUT_MESSAGE', 'SHORT_PRODUCT_EXPIRED_MESSAGE', 'PRODUCT_EXPIRED'].includes(
            item.attributes.error?.type || ''
          )
      ),
    [cartItems]
  );

  const invalidItems = useMemo(
    () =>
      cartItems.filter(
        item =>
          item.attributes.isProductAvailable &&
          [
            'SHORT_SIZE_SOLD_OUT_MESSAGE',
            'SHORT_QUANTITY_EXCEEDED_MESSAGE',
            'ORDER_LIMIT_EXCEEDED'
          ].includes(item.attributes.error?.type || '')
      ),
    [cartItems]
  );

  const totalUnavailable = [...unavailableItems, ...invalidItems];

  const personalizationRequiredItems = useMemo(
    () => cartItems.filter(item => item.attributes.error?.type === 'PERSONALIZATION_ERROR'),
    [cartItems]
  );

  return {
    cartItems,
    availableNowItems,
    preorderItems,
    unavailableItems,
    invalidItems,
    totalUnavailable,
    personalizationRequiredItems
  };
};
